<template>
  <v-dialog
    :fullscreen="$vuetify.breakpoint.smAndDown"
    v-model="dialog"
    @keydown.esc="cancel"
    scrollable
    :max-width="$vuetify.breakpoint.smAndDown ? 'none' : '600px'"
    content-class="fullscreen-dialog"
    persistent
  >
    <v-card class="dialog-card">
      <v-toolbar color="primary" dense class="header primaryText--text">
        <v-row>
          <v-col cols="2" align-self="end">
            <v-btn text @click="close">{{ $t("close") }}</v-btn>
          </v-col>

          <v-col cols="8" class="d-flex justify-center align-center">
            <div>
              <v-toolbar-title
                class="header-title1"
                v-if="$appMode == 0 && $store.state.store != null && $store.state.store.info != null"
                >{{ $store.getters.storeName }}</v-toolbar-title
              >
              <v-toolbar-title class="header-title2">{{ $t("privacy_policy") }}</v-toolbar-title>
            </div>
          </v-col>

          <v-col cols="2" align-self="end" style="text-align:right"></v-col>
        </v-row>
      </v-toolbar>

      <v-card-text>
        <pre>
      This Privacy Policy describes how your personal information is collected, used, and shared when you visit or make a purchase from order.mrsdigi.com (the “Site”).
      Personal information we collect
      When you visit the Site, we automatically collect certain information about your device, including information about your web browser, IP address, time zone, and some of the cookies that are installed on your device. Additionally, as you browse the Site, we collect information about the individual web pages or products that you view, what websites or search terms referred you to the Site, and information about how you interact with the Site. We refer to this automatically-collected information as “Device Information”.
      We collect Device Information using the following technologies:
      - “Cookies” are data files that are placed on your device or computer and often include an anonymous unique identifier. For more information about cookies, and how to disable cookies, visit http://www.allaboutcookies.org.
      - “Log files” track actions occurring on the Site, and collect data including your IP address, browser type, Internet service provider, referring/exit pages, and date/time stamps.
      Additionally when you make a purchase or attempt to make a purchase through the Site, we collect certain information from you, including your name, addresses, payment information, email address, and phone number. We refer to this information as “Order Information”. We use Global Payments to collect payments for the order. For more information related to payment information, visit https://www.globalpaymentsinc.com/en-ca/privacy-statement.
      When we talk about “Personal Information” in this Privacy Policy, we are talking both about Device Information and Order Information.
      How do we use your personal information?
      We use the Order Information that we collect generally to fulfill any orders placed through the Site. Additionally, we use this Order Information to:
      - Communicate with you;
      - Screen our orders for potential risk or fraud;
      - Transfer the orders information to the corresponding companies to process the order; and
      - When in line with the preferences you have shared with us, provide you with information or advertising relating to our products or services.
      We use the Device Information that we collect to help us screen for potential risk and fraud (in particular, your IP address), and more generally to improve and optimize our Site (for example, by generating analytics about how our customers browse and interact with the Site).
      Sharing you personal Information
      We do not share your Personal Information with third parties. We only share your information to the corresponding companies that handling your order. We also use Google Analytics to help us understand how our customers use the Site -- you can read more about how Google uses your Personal Information here: https://www.google.com/intl/en/policies/privacy/. You can also opt-out of Google Analytics here: https://tools.google.com/dlpage/gaoptout.
      Finally, we may also share your Personal Information to comply with applicable laws and regulations, to respond to a subpoena, search warrant or other lawful request for information we receive, or to otherwise protect our rights.
      Do not track
      Please note that we do not alter our Site’s data collection and use practices when we see a Do Not Track signal from your browser.
      Data retention
      When you place an order through the Site, we will maintain your Order Information for our records unless and until you ask us to delete this information.
      Changes
      We may update this privacy policy from time to time in order to reflect, for example, changes to our practices or for other operational, legal or regulatory reasons.
      Minors
      The Site is not intended for individuals under the age of 16.
      Contact us
      For more information about our privacy practices, if you have questions, or if you would like to make a complaint, please contact us by e‑mail at customerservices@mrsdigi.com or by mail using the details provided below:
      MRS DIGI INC.
      290 Yorktech Drive Unit 11,
      Markham, Ontario, L6G 0A7
      Canada.
        </pre>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {},

  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,
  }),

  created() {},

  computed: {},

  methods: {
    open() {
      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    close() {
      this.resolve(false);
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
pre {
  white-space: pre-line;
  font-family: inherit;
  padding: 20px 0px;
}
</style>
